module.exports = __webpack_public_path__ + "media/images/pages/secondary-senior-leaders/anne-cuffe-davies-c9295d7b0a86359c203244c92e0da1a1.jpg";